import { render, staticRenderFns } from "./SessionsBar.vue?vue&type=template&id=02ddc089"
import script from "./SessionsBar.vue?vue&type=script&lang=js"
export * from "./SessionsBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports